import { Collapse } from 'bootstrap'
import React, { Component } from 'react'
import { Card, CardDeck, Col, Container, Table } from 'react-bootstrap'
import shvm from '../photo/shvm.jpg'

export default class Shvm extends Component {
    render() {
        return ( 
            <Container >
                <h1  className="h1 ">Шарапов Валерій Михайлович</h1>
                <hr />
                <div className="about-teach">
                    <Col sm={7}>
                        
                        <p className="p"><b>Валерій Михайлович Шарапов</b>  - заслужений діяч науки і техніки України, 
                        доктор технічних наук, професор, завідуючий кафедрою комп'ютерних та інформаційних 
                        технологій в приладобудуванні з 1999  по жовтень 2014 року Черкаського державного технологічного університету.</p>
                        <h3 className="text-center"><b>Біографія</b> </h3><hr />
                        
                        
                        <p className="p">Закінчив Шосткинский хіміко-технологічний технікум в 1962 році 
                        (технологія виробництва взривчатих речовин), філія Московського інженерно-фізичного 
                        інституту (МИФИ) в 1969 році (автоматика та електроніка ядерних установ).</p>

                        <p className="p">Кандидатську диссертацію захистив у 1977 році в Томському інституті 
                        автоматики, електроніки та системного управління, докторську - у 1996 році в Одеському
                        національному політехнічному університеті.</p>
                        <p className="p">Робота в атомному центрі «Томськ-7», а також на підприємствах оборонної 
                        та електронної промисловості (НПО «Фонон»). Некоторые приборы и системы, в разработке
                        которых принимает участие В. М. Шарапов, використовується в промисловості. У Черкаському 
                        державному технологічному університеті працював за сумісництвом з 1978 року, постійно - 
                        з 1993 року.</p>
                        <p className="p">Викладав дисциплини: </p>
                        <ul>
                            <li >«Датчики»,</li>
                            <li >«Технологія приладобудування»,</li>
                            <li >«Технологія навчання»,</li>
                            <li >«Основи наукових досліджень»,</li>
                            <li >«Менеджмент» та ін.</li>
                        </ul>
                        
                        <p className="p"> Робота за сумісним професором та зав. кафедрой менеджмента 
                        Східно-європейського університету економіки та менеджменту (м. Черкаси).</p>

                        <h3 className="text-center"><b> Наукова діяльність</b></h3><hr />
                    
                        <p className="p"></p>
                        <p className="p">Інтереси: датчики, прибори та системи для атомної, ракетної промисловості, 
                        медичні прибори, п'єзоелектричні датчики, системний аналіз, технології управління 
                        соціальними системами, неруйнівні методи контролю та інше.</p>  
                        <p className="p">Руководитель научной школы пьезотехники. У рамках наукової школи 
                        захищено 2 докторські та 18 кандидатських дисертацій.</p>  
                        <p className="p">Автор більше 900 наукових публікацій, у тому числі 19 монографій та 
                        навчальних посібників, більше 500 патентів на винахід.</p>  <hr />  
                    
                    </Col>
                    <Col sm={5}>
                        
                        <CardDeck border="dark" className='m-3'>
                            <Card className="card">
                                <img
                                    
                                    src={shvm}
                                />
                                <Card.Body>
                                    <Card.Title  className="table-title"> <span ><b> ШАРАПОВ <br /> Валерій  Михайлович</b></span> </Card.Title> <hr />
                                    <Table >
                                        
                                        <tr>
                                            <td className="table-col-1" > Місце роботи </td> 
                                            <td className="table-col-2"> Черкаський державний технологічний університет </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Освіта </td> 
                                            <td className="table-col-2" > 
                                                <ul>
                                                    <li>Шосткинський хіміко-технологічний технікум (1962)</li>
                                                    <li>філіал Московського інженерно-фізичного інституту (МИФИ)(1969)</li>
                                                </ul>
                                                
                                            </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Науковий ступінь</td> 
                                            <td className="table-col-2 "> доктор технічних наук </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Наукове звання</td> 
                                            <td className="table-col-2 "> Професор </td>

                                        </tr>
                                    </Table>
                                    
                                    
                                </Card.Body>
                            </Card>
                        </CardDeck>
                        
                    </Col>
                    
                       
                </div>
            </Container>
        )
    }
}